import styled from 'styled-components';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
  margin-top: ${({ theme }) => theme.spacing.xm};
`;

export const CalendarIconContainer = styled.div`
  position: ${({ theme }) => theme.positions.absolute};
  top: ${({ theme }) => theme.spacing.m};
  right: ${({ theme }) => theme.spacing.m};
`;

export const StyledMyAuditContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 88px ${({ theme }) => theme.spacing.m};
`;

export const StyledTextLabel = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const InputContainerDatePiker = styled.div`
  justify-content: center;
  align-items: center;
  position: ${({ theme }) => theme.positions.relative};
  width: 100%;

  & .myaudit-filter-date-picker {
      height: ${({ theme }) => theme.height.h6};
      width: 100%;
      border: ${({ theme }) => `1px solid ${theme.colors.platinumDark}`};
      border-radius: ${({ theme }) => theme.spacing.s};
      padding: 0 11px; // added this temporarily when doing a myLqa revamp this will be removed 
  }
    
  .react-datepicker-wrapper {
    width: 100%;
  }
`;
